export default function LeadershipListing(el) {
    const filtersForm = el.querySelector('.leadership-listing__form');
    const filters = el.querySelector('.leadership-listing__filters');
    const filterButtons = filters.querySelectorAll('[data-filter-button]');
    const checkboxes = filters.querySelectorAll('input[type="checkbox"]');
    const radios = filters.querySelectorAll('input[type="radio"]');
    const clearAllBtns = el.querySelectorAll('.leadership-listing__clear-filters');
    const selectAllBtns = filters.querySelectorAll('label[for*="select-all"]');
    const chipsContainer = el.querySelector('.leadership-listing__chips');
    const loadingOverlay = el.querySelector('.loader-wrapper');

    filterButtons.forEach(button => {
        button.addEventListener('click', () => {
            switch (button.dataset.filterButton) {
            case 'dropdown':
                if (button.classList.contains('active')) {
                    button.classList.remove('active');
                    button.nextElementSibling.classList.remove('active');
                } else {
                    filterButtons.forEach(btn => {
                        btn.classList.remove('active');
                        if (btn.nextElementSibling) {
                            btn.nextElementSibling.classList.remove('active');
                        }
                    });
                    button.classList.add('active');
                    button.nextElementSibling.classList.add('active');
                }
                break;
            case 'radio':
                break;
            default:
                //
            }
        });
    });

    clearAllBtns.forEach(clearAllBtn => {
        clearAllBtn.addEventListener('click', () => {
            checkboxes.forEach(checkbox => {
                checkbox.checked = false;
            });

            radios.forEach(radio => {
                radio.checked = false;
            });
            filtersForm.dispatchEvent(new Event('change'));
        });
    });

    selectAllBtns.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            const parentList = e.target.closest('.leadership-listing__filters-options');
            const groupCheckboxes = parentList.querySelectorAll('input[type="checkbox"]');
            groupCheckboxes.forEach(checkbox => {
                if (e.target.previousElementSibling.checked === false) {
                    checkbox.checked = true;
                } else {
                    checkbox.checked = false;
                }
            });
            filtersForm.dispatchEvent(new Event('change'));
        });
    });

    const createChip = (value, text) => {
        if (value.includes('select-all')) {
            return;
        }

        const li = document.createElement('li');
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('data-value', value);
        button.textContent = text;
        li.appendChild(button);
        li.setAttribute('data-value', value);
        chipsContainer.appendChild(li);
    };

    const removeChip = value => {
        chipsContainer.removeChild(chipsContainer.querySelector(`li[data-value="${value}"]`));
    };

    chipsContainer.addEventListener('click', e => {
        if (e.target.tagName === 'BUTTON' && e.target.hasAttribute('data-value')) {
            const value = e.target.getAttribute('data-value');
            const checkbox = filters.querySelector(`input[type="checkbox"][value="${value}"]`);
            checkbox.checked = false;
            filtersForm.dispatchEvent(new Event('change'));
        }
    });

    async function updateCards(url) {
        loadingOverlay.classList.add('active');

        const response = await fetch(url);
        const htmlString = await response.text();
        const htmlNode = document.createElement('html');
        htmlNode.innerHTML = htmlString;

        const peopleSelector = '#leadership-listing-people';
        const paginationSelector = '#leadership-listing-pagination';

        const peopleNode = htmlNode.querySelector(peopleSelector);
        const paginationNode = htmlNode.querySelector(paginationSelector);

        document.querySelector(peopleSelector).innerHTML = peopleNode.innerHTML;
        document.querySelector(paginationSelector).innerHTML = paginationNode.innerHTML;

        loadingOverlay.classList.remove('active');
    }

    function updateChips() {
        checkboxes.forEach(checkbox => {
            if (checkbox.checked) {
                if (!chipsContainer.querySelector(`li[data-value="${checkbox.value}"]`)) {
                    createChip(checkbox.value, checkbox.nextElementSibling.innerText);
                }
            } else if (chipsContainer.querySelector(`li[data-value="${checkbox.value}"]`)) {
                removeChip(checkbox.value);
            }
        });

        // this should be manageable via :has(:empty) in css but Safari has bugs...
        const hasChips = chipsContainer.querySelectorAll(':scope > *').length;
        const cssHasChips = 'has-chips';

        if (hasChips) {
            el.classList.add(cssHasChips);
        } else {
            el.classList.remove(cssHasChips);
        }
    }

    function updateCount() {
        let filterCountNode;
        filterButtons.forEach(button => {
            switch (button.dataset.filterButton) {
            case 'dropdown':
                filterCountNode = button.querySelector('[data-filter-count]');
                if (filterCountNode) {
                    const numItemsChecked = button.parentElement.querySelectorAll('input[name]:checked').length;
                    filterCountNode.innerText = numItemsChecked > 0 ? `(${numItemsChecked})` : '';
                }
                break;
            default:
            }
        });
    }

    filtersForm.addEventListener('change', () => {
        updateChips();
        updateCount();

        const formData = new FormData(filtersForm);
        const params = new URLSearchParams(formData);
        const url = `${window.location.pathname}?${params.toString()}`;
        window.history.pushState({}, '', url);

        updateCards(url);
    });

    window.addEventListener('popstate', () => {
        // Parse URL params
        const params = new URLSearchParams(window.location.search);

        // Update checkboxes based on params
        checkboxes.forEach(checkbox => {
            const { name } = checkbox;
            const { value } = checkbox;
            const paramValues = params.getAll(name);
            checkbox.checked = paramValues.includes(value);
        });

        // Update chips UI
        checkboxes.forEach(checkbox => {
            if (checkbox.value.includes('select-all')) return;
            if (checkbox.checked) {
                if (!chipsContainer.querySelector(`li[data-value="${checkbox.value}"]`)) {
                    createChip(checkbox.value, checkbox.nextElementSibling.innerText);
                }
            } else if (chipsContainer.querySelector(`li[data-value="${checkbox.value}"]`)) {
                removeChip(checkbox.value);
            }
        });

        // Update cards
        updateCards(window.location.href);
    });

    // load chips on page load if query params
    updateChips();
    updateCount();
}
